module.exports = {"data":{"site":{"siteMetadata":{"title":"Learn React Design","description":"Complete crouse about the most best tools and design .","keywords":"react course, react for designers"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 106
// module chunks = 60335399758886 114276838955818